/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyAdvancementRuleCreateRequest
 */
export interface LegacyAdvancementRuleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    sourceStageId: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    sourceGroupId?: string;
    /**
     * 
     * @type {number}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    sourcePosition: number;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    targetSlotId: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyAdvancementRuleCreateRequest
     */
    label?: string;
}

/**
 * Check if a given object implements the LegacyAdvancementRuleCreateRequest interface.
 */
export function instanceOfLegacyAdvancementRuleCreateRequest(value: object): value is LegacyAdvancementRuleCreateRequest {
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('sourceStageId' in value) || value['sourceStageId'] === undefined) return false;
    if (!('sourcePosition' in value) || value['sourcePosition'] === undefined) return false;
    if (!('targetSlotId' in value) || value['targetSlotId'] === undefined) return false;
    return true;
}

export function LegacyAdvancementRuleCreateRequestFromJSON(json: any): LegacyAdvancementRuleCreateRequest {
    return LegacyAdvancementRuleCreateRequestFromJSONTyped(json, false);
}

export function LegacyAdvancementRuleCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyAdvancementRuleCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'],
        'sourceStageId': json['sourceStageId'],
        'sourceGroupId': json['sourceGroupId'] == null ? undefined : json['sourceGroupId'],
        'sourcePosition': json['sourcePosition'],
        'targetSlotId': json['targetSlotId'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function LegacyAdvancementRuleCreateRequestToJSON(json: any): LegacyAdvancementRuleCreateRequest {
    return LegacyAdvancementRuleCreateRequestToJSONTyped(json, false);
}

export function LegacyAdvancementRuleCreateRequestToJSONTyped(value?: LegacyAdvancementRuleCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'sourceStageId': value['sourceStageId'],
        'sourceGroupId': value['sourceGroupId'],
        'sourcePosition': value['sourcePosition'],
        'targetSlotId': value['targetSlotId'],
        'label': value['label'],
    };
}

